<template>

    <div class="box box-solid">
        <div class="box-header">
            <h2 class="box-title">{{ getOvertimeYear }} &ndash; {{ lang.get("timeregistration.overtime.quarter") }} {{ quarter }}</h2>
        </div>
        <div class="box-body no-padding table-responsive">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th class="text-center">{{ lang.get("timeregistration.overtime.weeknr") }}</th>
                        <th class="text-center">{{ lang.get("timeregistration.overtime.registeredhours") }}</th>
                        <th class="text-center">{{ lang.get("timeregistration.overtime.holidayhours") }}</th>
                        <th class="text-center">{{ lang.get("timeregistration.overtime.plannedholidayhours") }}</th>
                        <th class="text-center">{{ lang.get("timeregistration.overtime.contracthours") }}</th>
                        <th class="text-center">{{ lang.get("timeregistration.overtime.overtime") }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="week in getForQuarter">
                        <td class="text-center">{{ week.weeknr }}</td>
                        <td class="text-center">{{ week.timeregistrationhours }}</td>
                        <td class="text-center">{{ week.holidayhours }}</td>
                        <td class="text-center">{{ week.plannedholidayhours }}</td>
                        <td class="text-center">{{ week.contracthours }}</td>
                        <td class="text-center">{{ getWeekOvertime(week) }}</td>
                    </tr>
                </tbody>
                <tfoot style="font-weight:700;">
                    <tr>
                        <td class="text-right">{{ lang.get("global.total") }}</td>
                        <td class="text-center">{{ totalTimeregistrationHours }}</td>
                        <td class="text-center">{{ totalHolidayhours }}</td>
                        <td class="text-center">{{ totalPlannedHolidayHours }}</td>
                        <td class="text-center">{{ totalContracthours }}</td>
                        <td class="text-center">{{ totalOvertime }}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
        <div class="overlay" v-if="isLoading">
            <i class="fa fa-refresh fa-spin"></i>
        </div>
    </div>

</template>

<script>

    import { mapGetters } from 'vuex';
    import Lang from '../../Lang';

    export default {

        computed: {
            ...mapGetters([
                "getOvertime",
                "getOvertimeYear",
                "isLoading",
            ]),

            getForQuarter() {
                // Check if the entry exists
                if (!this.getOvertime[this.quarter]) {
                    // Return empty array
                    return [];
                }
                // Return the overtime array
                return this.getOvertime[this.quarter];
            },

            totalTimeregistrationHours() {
                let total = 0;
                this.getForQuarter.forEach((ot) => total += ot.timeregistrationhours);
                total = Math.round((total + Number.EPSILON) * 100) / 100;
                return total;
            },
            totalHolidayhours() {
                let total = 0;
                this.getForQuarter.forEach((ot) => total += ot.holidayhours);
                return total;
            },
            totalContracthours() {
                let total = 0;
                this.getForQuarter.forEach((ot) => total += ot.contracthours);
                return total;
            },
            totalOvertime() {
                let total = 0;
                this.getForQuarter.forEach((ot) => total += this.getWeekOvertime(ot));
                return total;
            },
            totalPlannedHolidayHours() {
                let total = 0;
                this.getForQuarter.forEach((ot) => total += ot.plannedholidayhours);
                return total;
            },
        },

        data() {
            return {
                lang:Lang,
            }
        },

        methods: {

            getTotals() {
                return {
                    quarter: this.quarter,
                    totalTimeregistrationHours: this.totalTimeregistrationHours,
                    totalHolidayhours: this.totalHolidayhours,
                    totalContracthours: this.totalContracthours,
                    totalOvertime: this.totalOvertime,
                    totalPlannedHolidayHours: this.totalPlannedHolidayHours,
                };
            },

            getWeekOvertime(week) {
                let overtime = (parseFloat(week.timeregistrationhours) + parseFloat(week.holidayhours)) - parseFloat(week.contracthours);

                overtime = Math.round((overtime + Number.EPSILON) * 100) / 100;

                return overtime > 0 ?
                    overtime :
                    0;
            },

        },

        name: "OvertimeQuarter",

        props: {
            quarter: {
                required:true,
            }
        }

    }


</script>
